/* eslint @okta/okta-ui/no-specific-modules: 0, max-params: 0, max-statements: 0 */
import Handlebars from 'handlebars';
import moment from 'moment';
import _ from '../underscore-wrapper';

function formatDate(format, dateInISOString) {
  return moment
    .utc(dateInISOString)
    .utcOffset('-07:00')
    .format(format);
}

Handlebars.registerHelper('shortDate', _.partial(formatDate, 'MMM Do'));
Handlebars.registerHelper('mediumDate', _.partial(formatDate, 'MMMM DD, YYYY'));
Handlebars.registerHelper('longDate', _.partial(formatDate, 'MMMM DD, YYYY, h:mma'));
Handlebars.registerHelper('formatDate', formatDate);

export default Handlebars;



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/util/handlebars/helper-date.js


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/util/handlebars/helper-date.js